import { render, staticRenderFns } from "./controllist.vue?vue&type=template&id=1892f2ba"
import script from "./controllist.vue?vue&type=script&lang=js"
export * from "./controllist.vue?vue&type=script&lang=js"
import style0 from "./controllist.vue?vue&type=style&index=0&id=1892f2ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports